export default __webpack_public_path__ + "static/media/Suyane_Mike_HickDuarte_33389.3d998116.jpg";